<template>
    <b-modal :id="modalId" size="lg" hide-footer hide-header no-close-on-backdrop no-close-on-esc>
        <div id="header">
            <span class="title">Editar Resultado Chave</span>
            <i class="close-button fas fa-times" @click="closeModal" />
        </div>
        <b-row>
            <b-col class="descriptions-column" cols="5">
                <Descriptions />
            </b-col>
            <b-col class="form-column">
                <Form ref="form" @submit="onSubmit" @cancel="closeModal" :isSubmitting="isSubmitting" />
            </b-col>
        </b-row>
    </b-modal>
</template>
<script>
import api from '@/services/api'
import { Form } from './components'
import { Descriptions } from '../new/components'
import { success, danger } from '@/lib/notification'

export default {
    components: {
        Form,
        Descriptions,
    },
    data() {
        return {
            modalId: 'edit-key-result-modal',
            isSubmitting: false,
        }
    },
    mounted() {
        this.$bvModal.show(this.modalId)
    },
    methods: {
        async onSubmit(payload) {
            try {
                this.setIsSubmitting(true)
                await this.createObjective(payload)
                this.showSuccessNotification()
                this.closeModal()
            } catch (e) {
                console.error(e)
                this.showErrorNotification()
            } finally {
                this.setIsSubmitting(false)
            }
        },
        setIsSubmitting(value) {
            this.isSubmitting = value
        },
        createObjective(payload) {
            return api
                .put(`objectives/${payload.objective_id}/keyresults/${this.$route.params.resultId}`, payload)
                .then(() => {
                    this.$emit('updateKeyResults', payload.objective_id)
                })
        },
        showSuccessNotification() {
            success('Resultado chave atualizado com sucesso!')
        },
        showErrorNotification() {
            danger()
        },
        closeModal() {
            this.$router.back()
            this.$emit('onUpdatedKeyResult')
        },
    },
}
</script>

<style lang="scss" scoped>
#header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
        font-size: 24px;
        font-weight: 700;
        text-align: left;
        color: #009ada;
    }

    .close-button {
        color: #3b3f4e;
        cursor: pointer;
        font-size: 18px;
    }
}

::v-deep .modal-lg {
    max-width: 900px;
}

.descriptions-column {
    padding: 1rem;
}

.form-column {
    border-top: 0.5px solid #bec0c0;
    padding: 1rem;
}
</style>
